export function formatTime(timestamp?: string) {
  if (!timestamp) return "";
  const date = dateFromLocalIso(timestamp);
  return new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}

export function formatDateTime(timestamp?: string) {
  if (!timestamp) return "";
  const date = dateFromLocalIso(timestamp);
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}

export function formatDateHeading(timestamp?: string) {
  if (!timestamp) return "Unknown date";
  const date = dateFromLocalIso(timestamp);
  return new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function formatShortDate(timestamp?: string) {
  if (!timestamp) return "";
  const date = dateFromLocalIso(timestamp);
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function formatDateRange(start?: string, end?: string) {
  if (!start && !end) return "No date range";
  if (start && !end) return formatShortDate(start);
  if (!start && end) return formatShortDate(end);
  const startDate = dateFromLocalIso(start!);
  const endDate = dateFromLocalIso(end!);
  const sameYear = startDate.getFullYear() === endDate.getFullYear();
  const sameMonth = sameYear && startDate.getMonth() === endDate.getMonth();
  if (sameMonth) {
    return `${new Intl.DateTimeFormat("en-US", { month: "long" }).format(startDate)} ${startDate.getDate()} - ${endDate.getDate()}, ${endDate.getFullYear()}`;
  }
  if (sameYear) {
    return `${new Intl.DateTimeFormat("en-US", { month: "long", day: "numeric" }).format(startDate)} - ${new Intl.DateTimeFormat("en-US", { month: "long", day: "numeric", year: "numeric" }).format(endDate)}`;
  }
  return `${formatShortDate(start)} - ${formatShortDate(end)}`;
}

function dateFromLocalIso(timestamp: string) {
  const [date, time = "00:00:00"] = timestamp.split("T");
  const [year, month, day] = date.split("-").map(Number);
  const [hour, minute, second] = time.split(":").map(Number);
  return new Date(year, month - 1, day, hour, minute, second ?? 0);
}
